import { render } from "./ExtendedRegisterView.vue?vue&type=template&id=bf5638f0&scoped=true"
import script from "./ExtendedRegisterView.vue?vue&type=script&lang=js"
export * from "./ExtendedRegisterView.vue?vue&type=script&lang=js"

import "./ExtendedRegisterView.vue?vue&type=style&index=0&id=bf5638f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf5638f0"]])

export default __exports__